import DrawingSummary from "@/components/Exercises/DrawHappyPlace/DrawingSummary";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/happy-place/draw-summary"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "My Happy Place Drawings - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "happy-place.summary",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  return (
    <div className="max-w-xl mx-auto px-4 py-6">
      <DrawingSummary />
    </div>
  );
}
